module.exports = __webpack_public_path__ + "media/images/ok-8704ff97a098106104c21edd67459c25.png";